enum INSPECTION_TYPES {
    TECNORED_CENTER = "1",
    COPY_OF_POLICY = "2",
    MY_BARBUSS = "3"
};
  
export { INSPECTION_TYPES };